import I18n from 'I18n';
import { UnauthedHubSpotUserAvatar } from 'avatar-components/UnauthedHubSpotUserAvatar';
import { getSortedUsers } from '../../utils/UserUtils';
import { formatUserFullNameForDisplay } from '../../utils/UserUtils';
import { FilterOptionTypes } from './Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const makeUserSelectOption = (user, assetTypeDisplayName, multi) => {
  const {
    id,
    email,
    ownedAssetCount
  } = user;
  return {
    value: id,
    text: formatUserFullNameForDisplay(user),
    type: FilterOptionTypes.USER,
    ownedAssetCount,
    assetTypeDisplayName,
    multi,
    avatar: /*#__PURE__*/_jsx(UnauthedHubSpotUserAvatar, {
      size: "xs",
      hubSpotUserEmail: email
    })
  };
};
const getUserOptions = ({
  users,
  assetTypeDisplayName,
  userHasTeamAssignmentScope,
  multi
}) => {
  const options = !userHasTeamAssignmentScope || users.length === 0 ? [] : getSortedUsers(users).map(user => makeUserSelectOption(user, assetTypeDisplayName, multi));
  return [{
    text: I18n.text('ui-asset-management-lib.labels.users'),
    options
  }];
};
export default getUserOptions;